export default __webpack_public_path__ + "static/media/engagement_pic_collage.d1dca179.png";